import { Modal } from "antd";
import { Trans, useTranslation } from "react-i18next";
import imgAnnoDominiWeb from "shared/assets/images/anno-domini-sem-texto.png";
import "explorer/pages/new-estagio-artista/campanhas-especiais/CampanhasEspeciais.scss";
import { isMobile } from "react-device-detect";
import { getLoggedUserArtist } from "explorer/reducers/artistas";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { ClientSpecialCampaignApprovalEnum } from "shared/enums/ClientSpecialCampaignApprovalEnum";
import { SpecialCampaignEnum } from "shared/enums/SpecialCampaignEnum";
import {
  getDialogEventNameByApproval,
  getSpecialCampaign,
} from "shared/helpers/special-campaign-helpers";
import { specialCampaignRequestConfirmNotification } from "shared/service/StrmService";
import { dataLayerDialogViewedEvent } from "event-tracker/gtm-events";
import { getSpecialCampaignEventParams } from "event-tracker/special-campaign-events";
import { useEffect } from "react";

interface ModalCampaignADResponseProps {
  open: boolean;
  onCancel: () => void;
}

const ModalCampaignADResponse: React.FC<ModalCampaignADResponseProps> = (
  props
) => {
  const { open, onCancel } = props;
  const dispatch = useDispatch();
  const history = useHistory();
  const { t } = useTranslation();
  const { userArtist } = useSelector((state: any) => state.artists);

  const specialCampaign = getSpecialCampaign(
    userArtist?.specialCampaign,
    SpecialCampaignEnum.AnnoDomini
  );

  useEffect(() => {
    if (
      specialCampaign?.approval !== undefined &&
      specialCampaign?.approval !== null
    ) {
      dataLayerDialogViewedEvent(
        getDialogEventNameByApproval(
          ClientSpecialCampaignApprovalEnum.Approved
        ),
        getSpecialCampaignEventParams(SpecialCampaignEnum.AnnoDomini)
      );
    }
  }, [specialCampaign?.approval]);

  const getTranslateApproval = (
    approvalVal: ClientSpecialCampaignApprovalEnum
  ): any => {
    if (!approvalVal) return {};
    const approval =
      approvalVal === ClientSpecialCampaignApprovalEnum.Approved
        ? "approved"
        : "disapproved";
    return t(`pages.CampanhasEspeciais.AnnoDomini.response.${approval}`);
  };

  const onClickConfirma = async () => {
    if (specialCampaign?.shouldNotifyArtist) {
      await specialCampaignRequestConfirmNotification(
        specialCampaign.specialCampaignRequestId
      );
      dispatch(getLoggedUserArtist());
    }

    if (
      specialCampaign?.approval === ClientSpecialCampaignApprovalEnum.Approved
    ) {
      history.push("/distribua", {
        specialCampaign: SpecialCampaignEnum.AnnoDomini,
      });
    }

    onCancel();
  };

  const {
    textoSobreTitulo,
    titulo,
    textoDisclaimer,
    beneficios,
    botao,
    texto,
  } = getTranslateApproval(specialCampaign?.approval);

  return (
    <Modal
      open={open}
      footer={null}
      closable={true}
      maskClosable={false}
      className={`modal-campanha-especial ${isMobile ? "mobile" : "web"}`}
    >
      <div
        style={{
          background: `linear-gradient(180deg, rgba(25, 25, 25, 0.3) 0%, #1A1A1A 50%), url(${imgAnnoDominiWeb}) no-repeat`,
          backgroundSize: "cover",
          borderRadius: "8px 8px 0 0",
          minHeight: 330,
          width: "100%",
          position: "absolute",
        }}
      />

      <div className="" style={{ position: "relative" }}>
        <div className="conteudo">
          <div className="fundo-opaco" />
          <div className="wrapper-titulo">
            <span className="texto-sobre-titulo">{textoSobreTitulo}</span>
            <h1 className="titulo">{titulo}</h1>
            <span className="divider" />
          </div>
          <div className="wrapper-beneficios">
            <p className="text-disclaimer">
              <Trans>{texto}</Trans>
            </p>
            <p
              className="text-disclaimer"
              style={{
                margin: "20px 0px",
              }}
            >
              {textoDisclaimer}
            </p>
            <ul>
              {beneficios?.map((text: string) => (
                <li
                  className="circle-checkmark azul item-beneficio"
                  key={`${text}_TEXT`}
                >
                  {text}
                </li>
              ))}
            </ul>
            <div className="buttons">
              <button className="botao-roxo" onClick={onClickConfirma}>
                {botao}
              </button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ModalCampaignADResponse;
